import { storeStructure } from '../store/reducers';
import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import tableComposeExperienceAppReferences from './tableComposeExperienceAppReferences';
export default {
  attributeName: storeStructure.ComposeExperience,
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  createPath: routes.COMPOSE_EXPERIENCE_NEW,
  editURL: routes.COMPOSE_EXPERIENCE_EDIT,
  emptyMessage: "You don't have any composed experiences, click on the +new button to make a new one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of composed experience',
      canOrder: true,
      canFilter: true,
      exactWidth:'250px',
    },
    {
      attributeName: 'composeExperienceType',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Type of composed experience',
      canOrder: true,
      canFilter: true,
      exactWidth:'150px',
      filterSelectOptions: [
          { name: 'Type filter...', value: 'no-filter'},
          { name: 'Multicam', value: 'multicam' },
          { name: 'Url', value: 'url' },
          { name: 'FromVod', value: 'fromVod' },
      ]
    },
    {
      attributeName: 'url', // TO FIX STREAM 9120 (fix edit/update)
      label: 'Url',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'First URL',
      canOrder: true,
      canFilter: true,
      width:'650px',
    },
    {
      attributeName: 'id',    
      label: 'Link to references',
      type: FormInputTypes.BUTTON_POPUP,
      iconSize:'2x',
      icon: IconType.LINK,
      helpText: 'open list of app references',
      canOrder: false,      
      canFilter: false,
      exactWidth:'100px',
      openUrl:'composeExperienceReferences',
      enabledWhen:{"field":"noRef","values":"not-null"},
      formConfig:
      {
        title: 'Compose Experience References',
        description:'This compose experience is referenced by the following apps:',
        type: FormInputTypes.TABLE,
        fields: [
          {
            attributeName: 'appReferences',
            type: FormInputTypes.TABLE,
            label: '',
            helpText: '',
            configFile: tableComposeExperienceAppReferences
          }
        ]
        
      },
      
    },
    {
      attributeName: 'noRef',
      label: 'Number of References',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of composed experience',
      default: '0',      
      hidden: true
    },
    {
      attributeName: 'created_at',
      label: 'Created At',
      type: FormInputTypes.TIMESTAMP,
      helpText: 'Date the composed experience was created at',
      canOrder: true,      
      canFilter: true,
    },
  ],
};
